import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './insertText.css';
import {
  addText,
  toggleIsActive,
} from '../../../../redux/actions/entities/texts';
import { addTextToPage } from './../../../../redux/actions/entities/pages';
import { generateId } from '../../../../redux/helpers';
import {
  DEFAULT_FONT_SIZE,
  DEFAULT_TEXT_COLOR,
  DEFAULT_FONT,
  TEXT_PROPERTIES,
} from '../../../../redux/helpers/texts';
import { coversWithText } from './../../../../helpers/coverHelper';

class InsertText extends Component {
  insertText = (isSpineText = false) => {
    const {
      texts,
      pageId,
      editorRatio,
    } = this.props;

    const dragWrapper = document.querySelector('.dragLimit').getBoundingClientRect();
    const interactiveLayer = document.querySelector('.InteractiveLayer').getBoundingClientRect();
    const positions = {
      x: (((dragWrapper.left - interactiveLayer.left) + (dragWrapper.width / 2)) * editorRatio) + (interactiveLayer.width / 2),
      y: (((dragWrapper.top - interactiveLayer.top) + (dragWrapper.height / 2)) * editorRatio) + (interactiveLayer.height / 2),
    };

    // Keep previous fontFamily, size and color
    const lastProperties = this.innerPageTexts().slice(-1)[0];
    const index = generateId(Object.keys(texts), 10000);
    const textProperties = Object.assign(TEXT_PROPERTIES, {
      id: index,
      color: lastProperties ? lastProperties.color : DEFAULT_TEXT_COLOR,
      font: lastProperties ? lastProperties.font : DEFAULT_FONT,
      fontSize: lastProperties ? lastProperties.fontSize : DEFAULT_FONT_SIZE,
      positions,
      isSpineText,
    });


    this.props.dispatch(addText(textProperties));
    this.props.dispatch(addTextToPage(pageId, index));
    this.props.dispatch(toggleIsActive(index));
  }

  hasCoverText = () => {
    const { texts } = this.props;
    return Object.values(texts).some(element => element.isSpineText);
  }

  innerPageTexts = () => {
    const { texts } = this.props;
    return Object.values(texts).filter(element => !element.isSpineText);
  }

  spineText = () => {
    const {
      lang,
      isTextLayout,
      coverType,
    } = this.props;

    if (!isTextLayout || !coversWithText().includes(coverType)) {
      return false;
    }
    return (
      <div className="flyleaf-wrapper spineText">
        <div>
          <button className="btn green-btn  " onClick={() => this.insertText(true)}>
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M11,4H9A2,2,0,0,0,7,6V7H3V8H13V6A2,2,0,0,0,11,4Zm1,3H8V6A1,1,0,0,1,9,5h2a1,1,0,0,1,1,1ZM3,13l10,3V15L9,13.8V11.2L13,10V9L3,12Zm5-1.5v2l-3.33-1ZM12,1a1,1,0,0,1-1,1H9A1,1,0,0,1,8,1V0H7V1A2,2,0,0,0,9,3h2a2,2,0,0,0,2-2V0H12Zm3-1V16h1V0ZM0,16H1V0H0Z" /></svg>
            {lang.spine_text}
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { lang } = this.props;

    return (
      <div className="colorWrapper border-left">
        <div className="flyleaf-wrapper">
          <div>
            <button className="btn green-btn " onClick={() => this.insertText(false)}>
              <i className="fa fa-font" />
              {lang.insert_text}
            </button>
          </div>
        </div>
        {this.spineText()}
      </div>
    );
  }
}

InsertText.defaultProps = {
  lang: {},
  texts: {},
  pageId: 0,
  editorRatio: 0,
  isTextLayout: false,
  coverType: '',
};

InsertText.propTypes = {
  lang: PropTypes.object,
  texts: PropTypes.object,
  pageId: PropTypes.number,
  editorRatio: PropTypes.number,
  isTextLayout: PropTypes.bool,
  coverType: PropTypes.string,
};

export default connect(state => ({
  texts: state.entities.texts,
}))(InsertText);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/insert-text/insertText.jsx